export default "__VITE_ASSET__DKFIKApj__"